import { render, staticRenderFns } from "./qcrbCloud.vue?vue&type=template&id=72127c6c&scoped=true&"
import script from "./qcrbCloud.vue?vue&type=script&lang=js&"
export * from "./qcrbCloud.vue?vue&type=script&lang=js&"
import style0 from "./qcrbCloud.vue?vue&type=style&index=0&id=72127c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72127c6c",
  null
  
)

export default component.exports